import { render, staticRenderFns } from "./VerifyOldPhone.vue?vue&type=template&id=4f6a3e04&scoped=true"
import script from "./VerifyOldPhone.vue?vue&type=script&lang=js"
export * from "./VerifyOldPhone.vue?vue&type=script&lang=js"
import style0 from "./VerifyOldPhone.vue?vue&type=style&index=0&id=4f6a3e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a3e04",
  null
  
)

export default component.exports